export const FETCH_EMAIL = 'line-up/email/FETCH_EMAIL';
export const UPDATE_EMAIL = 'line-up/email/UPDATE_EMAIL';
export const DELETE_EMAIL = 'line-up/email/DELETE_EMAIL';
export const CREATE_EMAIL = 'line-up/email/CREATE_EMAIL';
export const SEND_EMAIL_PREVIEW = 'line-up/email/SEND_EMAIL_PREVIEW';
